module.exports = __webpack_public_path__ + "static/media/peghook-v2.313ddd56.png";